import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Header from '../components/Header';
import './InstructionPage.css';

const InstructionPage = () => {
    const { examType, testId } = useParams();
    const navigate = useNavigate();

    return (
        <div className="instruction-container">
            <Header />
            <div className="instruction-content">
                <div className="instruction-box">
                    <h2>
                        IELTS Academic {examType ? examType.charAt(0).toUpperCase() + examType.slice(1) : ""}
                    </h2>

                    <p className="time-info">Time:</p>
                    <ul><li>Reading: 1 hours</li></ul>
                    <ul><li>Listening: 30 minutes</li></ul>
                    <ul><li>Writing: 1 hours</li></ul>

                    <div className="info-section">
                        <h3>INSTRUCTIONS TO CANDIDATES</h3>
                        <ul>
                            <li>Answer <strong>all</strong> the questions.</li>
                            <li>You can change your answers at any time during the test.</li>
                        </ul>
                    </div>

                    <div className="info-section">
                        <h3>INFORMATION FOR CANDIDATES</h3>
                        <ul>
                            <li>There are 40 questions in this test.</li>
                            <li>Each question carries one mark.</li>
                        </ul>
                    </div>

                    <button 
                        className="start-test-btn" 
                        onClick={() => {
                            const type = examType?.toLowerCase();

                            if (type === "writing") {
                                navigate(`/quiz/writing/${testId}`);
                            } 
                            else if (type === "reading") {
                                navigate(`/quiz/reading/${testId}`);
                            } 
                            else if (type === "listening") {
                                navigate(`/quiz/listening/${testId}`);
                            } 
                            else {
                                navigate(`/quiz/${type}/${testId}`);
                            }
                        }}
                    >
                        Start test
                    </button>
                </div>
            </div>
        </div>
    );
};

export default InstructionPage;